export default __webpack_public_path__ + "static/three-women-1de748d35a57230c08f48b5961e70d19.svg";